import { Contained, Text } from './AuthModalButton.styled';

export default function AuthModalButton({
    'aria-label': ariaLabel,
    children,
    'data-testid': dataTestId,
    disabled,
    screen,
    type = 'button',
    variant = 'black',
    onClick,
}: AuthModalButtonProps) {
    function handleClick() {
        if (onClick) {
            onClick?.(screen || 'login');
        }
    }

    if (variant === 'text') {
        return (
            <Text aria-label={ariaLabel} data-testid={dataTestId} disabled={disabled} type="button" onClick={handleClick}>
                {children}
            </Text>
        );
    }

    return (
        <Contained
            $alt={variant === 'white'}
            aria-label={ariaLabel}
            data-testid={dataTestId}
            disabled={disabled}
            type={type}
            onClick={handleClick}
        >
            {children}
        </Contained>
    );
}
